import HiddenMixin from './HiddenMixin';
import CollapsedMixin from './CollapsedMixin';
import mixin from 'privates/utils/mixin';

/**
 * @mixin HiddenCollapsedMixin
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.HiddenMixin
 * @mixes $w.CollapsedMixin
 * @memberof $w
 */
class HiddenCollapsedMixin {
}

mixin(HiddenCollapsedMixin.prototype, HiddenMixin.prototype);
mixin(HiddenCollapsedMixin.prototype, CollapsedMixin.prototype);
export default HiddenCollapsedMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/HiddenCollapsedMixin.es6